import { Input, Label } from '@favordelivery/tupperware'
import styled from 'styled-components'
import { inputErr } from '../styles/input'
import { mediaMobile, mediaTablet, mediaTabletAndMobile } from '../styles/breakPoints'
import PinFilled from '../../icons/PinFilled'
import { t, tStr } from '@utils/lang'

const Container = styled.div`
  position: relative;
`

const StyledInput = styled(Input)`
  font-size: var(--themeFontSizeBody);
  color: var(--themeColorForegroundPrimary);
  background: var(--themeColorBackgroundRecessed);
  border: none;
  width: 400px;
  margin-top: 0;
  padding-left: 40px;

  &::placeholder {
    font-size: var(--themeFontSizeBody);
    font-weight: var(--themeFontWeightNormal);
  }
  &.errorField {
    ${inputErr}
    background: var(--themeColorBackgroundRecessed);
  }
  ${mediaTablet} {
    width: 220px;
  }
  ${mediaMobile} {
    width: 100%;
  }
`
const StyledLabel = styled(Label)`
  font-size: ${p => p.theme.font.size.h4};
  font-weight: ${p => p.theme.font.weight.normal};
  color: var(--themeColorBetaSecondary);
  margin-bottom: 8px;
  ${mediaTabletAndMobile} {
    font-size: ${p => p.theme.font.size.title};
  }
`
const PinIcon = styled(PinFilled)`
  position: absolute;
  left: 8px;
  top: 12px;
`
const InputContainer = styled.div`
  position: relative;
`

const ZipField = ({ error, onChange, ...props }) => (
  <Container>
    <StyledLabel htmlFor="zip">{t('homeZipLabel_s')}</StyledLabel>
    <InputContainer>
      <PinIcon />
      <StyledInput
        {...props}
        id="zip"
        inputMode="numeric"
        pattern="[0-9]*"
        className={error ? 'errorField' : null}
        placeholder={tStr('homeZipPlaceholder_s')}
        onChange={evt => {
          const { target } = evt
          const { value } = target
          let newVal = value.match(/[0-9]*/g).join('')

          if (newVal.length > 5) {
            newVal = newVal.slice(0, 5)
            target.value = newVal
          }

          onChange(newVal)
        }}
      />
    </InputContainer>
  </Container>
)

export default ZipField
